import { Image, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import logo from "../../../../Assets/pnFin.png";

interface ISidePanelProps {
  className?: string;
}

const LoginSignupSidePanel: React.FC<ISidePanelProps> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={`${className} typoGraphySection`}>
      {/* <Image src={logo} preview={false} className="logoGreetings" /> */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
          flexDirection: "column",
        }}
      >
        <Typography.Title className="welcomeText" level={2}>
          {t("Welcome")}
        </Typography.Title>
        <Typography.Text className="typoText">
          {t("Hi, kindly fill in the details to proceed")}
        </Typography.Text>
      </div>
    </div>
  );
};

export default LoginSignupSidePanel;
